import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../api";

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const loadUser = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await api.get("/api/users/me");
      setUser(response.data);
    } catch (error) {
      console.error("Ошибка загрузки пользователя:", error);
      setUser(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  return (
    <UserContext.Provider value={{ user, isLoading, reloadUser: loadUser }}>
      {children}
    </UserContext.Provider>
  );
};
